import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ToolsAction } from "../../../actions";
import ToolsDescription from "../components/description";
import ToolsSearch from "../components/search";
import Table from "../../../components/table";
import { Sortable } from "../../../components/sort";
import { Confirm } from "../../../components/confirm";
import { EmptyState } from "../../../components/emptyState";
import { BoxLoading } from "../../../components/loading";
import { ToolsTop, ToolsBody, TruncateText } from "../style";
import { ToPersian } from "../../../lib/changeNumber";
import ToEnglish from "../../../lib/persianNumberToEnglish";

class Wallet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: null,
      sortField: "name",
      sortType: "asc",
      showModal: false
    };

    this.sortHandleClick = this.sortHandleClick.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.deleteHandleClick = this.deleteHandleClick.bind(this);
    this.rowRender = this.rowRender.bind(this);
    this.onEdit = this.onEdit.bind(this);
  }

  componentDidMount() {
    !this.props.list.length && this.props.getAll();
  }

  async sortHandleClick(sortField) {
    const { sortType } = this.state;

    this.setState({
      sortField,
      sortType: sortType === "desc" ? "asc" : "desc"
    });
  }

  onEdit(id) {
    this.props.history.push(`/tools/${id}/edit`);
  }

  onSearch(query) {
    this.setState({
      query: query
    });
  }

  deleteHandleClick(item) {
    this.setState({ showConfirm: true, deleteItemId: item.id });
  }

  rowRender(item) {
    const { accounting } = this.props;

    return (
      <Table.Row key={item.id}>
        <Table.Cell onClick={() => this.onEdit(item.id)} className="name">
          {item.name}
        </Table.Cell>
        {accounting && (
          <Table.Cell
            onClick={() => this.onEdit(item.id)}
            className="accounting"
          >
            {item.accounting_codes &&
              item.accounting_codes.map(account => account.code).join("-")}
          </Table.Cell>
        )}
        <Table.Cell
          onClick={() => this.onEdit(item.id)}
          className="description"
        >
          <TruncateText width="40vw">{item.description}</TruncateText>
        </Table.Cell>
        <Table.Cell className="row-controls-button">
          <div className="hidden-td">
            <i
              onClick={() => this.deleteHandleClick(item)}
              className="no-select icon mapsa-trash red"
              title="حذف"
            />
          </div>
        </Table.Cell>
      </Table.Row>
    );
  }

  render() {
    const description =
      "منظور از ابزار و ماشین آلات، اقلامی هستند که ماهیت مصرفی در پروژه ندارند و در پایان پروژه می توانند فروخته شده یا به پروژه دیگری انتقال یابند. مانند بالابر، بشکه، داربست و... در پروژه های ساختمانی.";
    const { loading, list, accounting } = this.props;
    const {
      showConfirm,
      deleteItemId,
      query,
      sortField,
      sortType
    } = this.state;
    const filteredList = list
      .filter(
        item =>
          !query ||
          item.name.indexOf(ToPersian(query)) !== -1 ||
          item.name.indexOf(ToEnglish(query)) !== -1
      )
      .sort((prev, next) =>
        sortType === "asc"
          ? prev[sortField] < next[sortField]
            ? -1
            : 1
          : prev[sortField] > next[sortField]
          ? -1
          : 1
      );

    return (
      <React.Fragment>
        {!loading ? (
          list.length !== 0 ? (
            <React.Fragment>
              <ToolsTop>
                <ToolsDescription
                  icon="icon mapsa-work"
                  color="#ffa726"
                  title="ابزار و ماشین‌آلات"
                  description={description}
                />
                <ToolsSearch onSearch={this.onSearch} query={query} />
              </ToolsTop>
              <ToolsBody>
                {filteredList.length > 0 ? (
                  <Table>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell className="name">
                          <Sortable
                            sort={{ sortField, sortType, value: "name" }}
                            currency={false}
                            label={"ابزار و ماشین آلات"}
                            sortHandleClick={this.sortHandleClick}
                          />
                        </Table.HeaderCell>
                        {accounting && (
                          <Table.HeaderCell className="accounting">
                            کد حسابداری
                          </Table.HeaderCell>
                        )}
                        <Table.HeaderCell
                          className="description"
                          style={{ maxWidth: "50%" }}
                        >
                          توضیحات
                        </Table.HeaderCell>
                        <Table.HeaderCell className="row-controls-button"></Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>{filteredList.map(this.rowRender)}</Table.Body>
                  </Table>
                ) : (
                  <EmptyState tabIcon={"icon mapsa-search"}>
                    متاسفانه موردی یافت نشد.
                  </EmptyState>
                )}
              </ToolsBody>
              <Confirm
                show={showConfirm}
                content={{
                  type: "danger",
                  icon: "icon mapsa-notification",
                  message: "آیا از پاک کردن این ابزار اطمینان دارید؟",
                  acceptButtonText: "حذف",
                  rejectButtonText: "انصراف"
                }}
                acceptHandler={() => {
                  this.props.remove(deleteItemId);
                  this.setState({ showConfirm: false });
                }}
                rejectHandler={() => this.setState({ showConfirm: false })}
                close={() => this.setState({ showConfirm: false })}
              />
            </React.Fragment>
          ) : (
            <EmptyState tabIcon={"icon mapsa-outline-layers"}>
              {description}
            </EmptyState>
          )
        ) : (
          <BoxLoading />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = store => {
  return {
    list: store.Tool.data,
    loading: store.Tool.loading,
    accounting:
      store.Init.data &&
      store.Init.data.project_setting.accounting_software !== null &&
      !!store.Init.data.project_setting.accounting_software.id
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAll: () => {
      dispatch(ToolsAction.getAllRequest());
    },
    setDefault: id => {
      dispatch(ToolsAction.setDefaultRequest(id));
    },
    remove: id => {
      dispatch(ToolsAction.removeRequest(id));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Wallet)
);

export const Sidebar = {
  addButton: { title: "ایجاد ابزار و ماشین‌آلات" },
  menu: [{ title: "ابزار و ماشین‌آلات", icon: "mapsa-work", link: "/tools" }]
};
